/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import DropdownStatus from 'DesignSystem/DropdownStatus/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SendAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/SendAction",
  from,
  disabled
  
}) {
let messageComposeStatusValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'status',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  from,
  disabled
  
})
  return (<React.Fragment
>
<DropdownStatus
  viewPath={`${viewPath}/DropdownStatus`}
 marginLeft="auto"
 from={from}
 data="message_compose.status"
 selected={messageComposeStatusValueData}
 isDisabled={disabled}
 onClick={onClick}
 width={240}
/>
{children}
</React.Fragment>)
}